import React from "react"
import { AnimateWrapper } from "@components/main/animate-wrapper/AnimateWrapper"

import * as s from "./RichTextWide.module.scss"

export const RichTextWide = ({ data, pageContext }) => {
  return (
    <AnimateWrapper>
      <div
        className={`${s.RichText} ${
          pageContext &&
          pageContext.slug == "have-a-wonderful-pint" &&
          s.RichText___christmas
        }`}
      >
        <div dangerouslySetInnerHTML={{ __html: data.richText }} />
      </div>
    </AnimateWrapper>
  )
}
